import React from 'react'
import {withRouter} from 'react-router-dom'
import {Button, DatePicker, Radio, Spin, Table} from 'antd'
import NineAndZeroRadio from '../../components/nineAndZeroRadio'
import moment from 'moment'
import {clickDownloadReserved, exportData, isDefaultYear} from '../../util/index'
import {LAST_MONTH, LAST_YEAR, THIS_MONTH, THIS_YEAR, TODAY, YESTERDAY,} from '../../const'
import {changeStringTime2, postData,} from '../../util'
import ReserveDetail from './components/reserveDetail'
import {API_DOMAIN} from '../../config'
import RecordDetail from "./components/recordDetail"

const {RangePicker} = DatePicker

class ClubExpend extends React.Component {
    state = {
        list: [],
        period: {
            start_time: moment().format('YYYY-MM-DD'),
            end_time: moment().format('YYYY-MM-DD'),
        },

        size: '0',
        visible: false,
        chosenRecord: {},
        loading: false,
        radioValue: 1,
        sum: 0,
    }

    componentWillUnmount() {
    }

    onChange = (value, dateString) => {
        if (value.length > 0) {
            this.setState({
                period: {
                    start_time: dateString[0],
                    end_time: dateString[1],
                },
            })
        } else {
            this.setState({
                period: {
                    start_time: null,
                    end_time: null,
                },
            }) //清除
        }
    }

    handleSizeChange = (e) => {
        this.setState({size: e.target.value})
        this.getCurrentTimeByType(e.target.value) //时间范围
    }

    getCurrentTimeByType = (type) => {
        let startTime
        let endTime
        const today = moment().format('YYYY-MM-DD')
        //http://www.findsrc.com/article/momentjs_get_date
        if (type === YESTERDAY) {
            //昨天
            endTime = startTime = moment().subtract(1, 'day').format('YYYY-MM-DD')
        } else if (type === TODAY) {
            //今日
            startTime = endTime = today
        } else if (type === LAST_MONTH) {
            //上月
            startTime = moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD')
            endTime = moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD')
        } else if (type === THIS_MONTH) {
            //本月
            startTime = moment().startOf('month').format('YYYY-MM-DD')
            endTime = today
        } else if (type === LAST_YEAR) {
            //去年
            startTime = moment()
                .subtract(1, 'year')
                .startOf('year')
                .format('YYYY-MM-DD')
            endTime = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
        } else if (type === THIS_YEAR) {
            //今年
            startTime = moment().startOf('year').format('YYYY-MM-DD')
            endTime = today
        }
        this.setState({
            period: {
                start_time: startTime,
                end_time: endTime,
            },
        })
    }

    handleButton = async () => {
        const params = {
            club_id: sessionStorage.getItem('club_id'),
            start_time:
                moment(this.state.period.start_time).format('YYYY-MM-DD HH:mm:ss') ||
                '',
            end_time:
                moment(this.state.period.end_time).format('YYYY-MM-DD HH:mm:ss') || '',
            statisticType: this.state.radioValue,
            recharge: 5,
            type: '',
            allReservation: 1,
        }
        this.setState({loading: true})

        postData(
            `${API_DOMAIN}/Home/BusinessApi/IncomeBusiness`,
            'POST',
            JSON.stringify(params)
        ).then((res) => {
            res.list.length > 0 &&
            res.list.map((item, index) => {
                item.bills[0].amount = (item.bills[0].amount / 100).toFixed(2)

                item.bills[0].refund_amount = (item.bills[0].refund_amount / 100).toFixed(2)

                item.bills[0].consume_time = isDefaultYear(item.bills[0].consume_time)

                item.bills[0].paying_time = isDefaultYear(item.bills[0].paying_time)

                if (item.bills[0].state == 1) {
                    item.bills[0].stateText = '已创建'
                    item.bills[0].textColor = '#222222'
                }
                if (item.bills[0].state == 0x10) {
                    item.bills[0].stateText = '已支付'
                    item.bills[0].textColor = '#693216'
                }
                if (item.bills[0].state == 0x20) {
                    item.bills[0].stateText = '已确认'
                    item.bills[0].textColor = '#2D8CFF'
                }
                if (item.bills[0].state == 0x30) {
                    item.bills[0].stateText = '已开始'
                    item.bills[0].textColor = '#45B3BB'
                }
                if (item.bills[0].state == 0x40) {
                    item.bills[0].stateText = '待取消'
                    item.bills[0].textColor = '#FF0000'
                }
                if (item.bills[0].state == 0x60) {
                    item.bills[0].stateText = '已完成'
                    item.bills[0].textColor = '#222222'
                }
                if (item.bills[0].state == 0x61) {
                    item.bills[0].stateText = '已取消'
                    item.bills[0].textColor = '#bbbbbb'
                }
            })
            this.setState({
                list: res.list,
                sum: (res.incomeSum / 100).toFixed(2),
            })
        })

        this.setState({loading: false})
    }

    onTypeEvent = (type) => {
        this.setState({
            radioValue: type,
        })
    }

    onShowModal = (record) => {
        this.setState({
            visible: true,
            chosenRecord: record,
        })
    }

    handleReserveOk = () => {
        this.setState({visible: false})
    }
    handleReserveCancel = () => {
        this.setState({visible: false})
    }

    exportDetail = (reportName) => async () => {
        // const { period, statisticType } = this.props
        const statisticType = this.state.radioValue
        const {list, period} = this.state
        console.log(period)
        console.log(statisticType)
        if (
            period &&
            period.start_time &&
            period.end_time &&
            list &&
            list.length > 0
        ) {
            const cid = sessionStorage.getItem('club_id')
            const res = await this.exportClubPurchaseRecord({
                clubId: cid,
                startTime: moment(period.start_time).format('YYYY-MM-DD HH:mm:ss'),
                endTime: moment(period.end_time).format('YYYY-MM-DD HH:mm:ss'),
                statisticType,
            })
            if (res) {
                const a = document.createElement('a')
                let href = window.URL.createObjectURL(res)
                a.href = href
                a.download = decodeURIComponent(`订单详情-${reportName}.xls`)
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(href)
            } else {
                message.error('导出失败')
            }
        }
    }

    exportClubPurchaseRecord = (body) => {
        const endpoint = `${API_DOMAIN}/Home/BusinessApi/exportPurchaseRecord`
        return exportData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
            return data
        })
    }

    getClassName = (state) => {
        return 'state' + state
    }

    render() {
        const {expendList, period, size, sum} = this.state

        const columns = [
            {
                title: 'id',
                dataIndex: ['bills', '0', 'id'],
                key: 'id',
            },
            {
                title: '订单号',
                dataIndex: ['bills', '0', 'serial_number'],
                key: 'serial_number',
            },
            {
                title: '球台名',
                dataIndex: ['bills', '0', 'table_name'],
                key: 'table_name',
            },
            {
                title: '用户',
                dataIndex: ['bills', '0', 'member_name'],
                key: 'member_name',
            },
            {
                title: '手机号',
                dataIndex: ['bills', '0', 'phone'],
                key: 'phone',
            },
            {
                title: '开始时间',
                dataIndex: ['bills', '0', 'start_time'],
                key: 'start_time',
                render: (text) => {
                    return isDefaultYear(changeStringTime2(text))
                },
            },
            {
                title: '结束时间',
                dataIndex: ['bills', '0', 'end_time'],
                key: 'end_time',
                render: (text) => {
                    return isDefaultYear(changeStringTime2(text))
                },
            },
            {
                title: '支付时间',
                dataIndex: ['bills', '0', 'paying_time'],
                key: 'paying_time',
            },
            {
                title: '预订方式',
                dataIndex: ['bills', '0', 'prepaid'],
                key: 'prepaid',
                render(text){
                    if (text){
                        return "套餐预订"
                    }else{
                        return "时段预订"
                    }
                }
            },
            {
                title: '支付金额',
                dataIndex: ['bills', '0', 'amount'],
                key: 'amount',
            },
            {
                title: '退款金额',
                dataIndex: ['bills', '0', 'refund_amount'],
                key: 'refund_amount',
            },
            {
                title: '状态',
                dataIndex: ['bills', '0', 'stateText'],
                key: 'stateText',
                render: (text, record, index) => {
                    return (
                        // <span className={this.getClassName(record.bills[0].state)}>
                        <span style={{color: record.bills[0].textColor}}>{text}</span>
                    )
                },
            },
            {
                title: '到店时间',
                dataIndex: ['bills', '0', 'consume_time'],
                key: 'consume_time',
            },
            {
                title: '操作',
                dataIndex: ['bills', '0', 'id'],
                key: 'id',
                render: (text, record, _) => {
                    return (
                        <RecordDetail id={record.bills[0].id}/>
                    )
                }
            }
        ]

        return (
            <div className="club_reserve_container">
                <Radio.Group
                    value={size}
                    onChange={this.handleSizeChange}
                    style={{display: 'block', marginBottom: '1rem'}}
                >
                    <Radio.Button value={YESTERDAY}>昨日</Radio.Button>
                    <Radio.Button value={TODAY}>今日</Radio.Button>
                    <Radio.Button value={LAST_MONTH}>上月</Radio.Button>
                    <Radio.Button value={THIS_MONTH}>本月</Radio.Button>
                    <Radio.Button value={LAST_YEAR}>去年</Radio.Button>
                    <Radio.Button value={THIS_YEAR}>今年</Radio.Button>
                </Radio.Group>
                <RangePicker
                    showTime={false}
                    format="YYYY-MM-DD"
                    placeholder={['开始时间', '结束时间']}
                    value={
                        period.start_time
                            ? [
                                moment(`${period.start_time}`, 'YYYY-MM-DD'),
                                moment(`${period.end_time}`, 'YYYY-MM-DD'),
                            ]
                            : null
                    }
                    onChange={this.onChange}
                />
                <NineAndZeroRadio typeEvent={this.onTypeEvent}/>
                <div style={{marginTop: '1rem'}}>
                    <Button type="primary" onClick={() => this.handleButton('2')}>
                        {/*<Link to={'/home/ClubBusiness/Report/'+ record_type}>显示</Link>*/}
                        显示
                    </Button>
                </div>

                <div
                    style={{
                        cursor: 'default',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginBottom: '1rem',
                        marginTop: '1rem',
                    }}
                >
                    <Button>
                        <a
                            id="test"
                            href={clickDownloadReserved(columns, this.state.list)}
                            download={`预订明细报表.csv`}
                        >
                            导出
                        </a>
                    </Button>

                    <div>
                        <Button
                            style={{marginRight: '30px'}}
                            onClick={this.exportDetail('预订明细报表')}
                        >
                            导出详细内容
                        </Button>
                        <Button
                            type="primary"
                            ghost
                            // onClick={() => copyToClip(sum)}
                        >
                            {/* 实收合计:￥{changeToDecimal(sum)}元 */}
                            实收合计:￥{sum}元
                        </Button>
                    </div>
                </div>

                {this.state.loading ? (
                    <Spin
                        tip="正在加载..."
                        className="level-loading"
                        style={{textAlign: 'center'}}
                    />
                ) : (
                    <Table
                        rowKey="id"
                        bordered
                        columns={columns}
                        dataSource={this.state.list}
                        size="middle"
                    />
                )}

                {this.state.visible && (
                    <ReserveDetail
                        visible={this.state.visible}
                        record={this.state.chosenRecord}
                        handleReserveOk={this.handleReserveOk}
                        handleReserveCancel={this.handleReserveCancel}
                    ></ReserveDetail>
                )}
            </div>
        )
    }
}

export default withRouter(ClubExpend)



// WEBPACK FOOTER //
// ./src/containers/ClubReserve/index.js